<template>
  <div id="centerLeft1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-pie" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">医生职称分布</span>
          <dv-decoration-1 class="dv-dec-1" />
        </div>
      </div>
      <div class="u-f">
        <div class="l1">
          <div class=" item" v-for="item in titleItem" :key="item.title">
            <p class=" colorBlue names" :title="item.name">{{ item.name }}</p>
            <div>
              <div class=" numbers">{{item.value}}</div>
            </div>
          </div>
        </div>
        <div class="r1">
          <CenterLeft2Chart />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import CenterLeft2Chart from "@/components/echart/centerLeft/centerLeft2Chart";
  export default {
    components: {
      CenterLeft2Chart
    },
    data() {
      return {
        titleItem: [

        ],
      }
    }
  };
</script>

<style lang="scss" scoped>
  #centerLeft1 {
    $box-width: 300px;
    $box-height: 410px;
    padding: 16px;
    height: $box-height;
    min-width: $box-width;
    border-radius: 5px;

    .bg-color-black {
      height: $box-height - 30px;
      border-radius: 10px;
    }

    .text {
      color: #c3cbde;
    }

    .dv-dec-1 {
      position: relative;
      width: 100px;
      height: 20px;
      top: -3px;
    }

    .chart-box {
      margin-top: 16px;
      width: 170px;
      height: 170px;

      .active-ring-name {
        padding-top: 10px;
      }
    }

    .r1 {
      flex: 1;
    }

    .l1 {
      width: 25%;

      .item {
        display: inline-block;
        width: 47%;
        background-color: rgba(19, 25, 47, 0.6);
        border-radius: 10px;
        margin-bottom: 2px;
        margin-right: 2px;


        .dv-dig-flop {
          width: 150px;
          height: 30px;
        }
        .names {
          font-weight: 600;
          text-align: center;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          font-size: 12px;
        }

        .numbers {
          color: #7ec699;
          font-size: 20px;
          font-weight: 700;
          padding:0 15px ;
        }
      }
    }
  }
</style>